import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const PaymentHistoryListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <div className="flex flex-col h-full overflow-hidden gap-2">
      {/* Page Header */}
      <div className="">
        <ATMPageHeader
          pageTitle="Payment History"
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          hideAddButton
          hideSearchBox
        />
      </div>

      {/* Table */}
      <div className="flex-1 overflow-hidden flex flex-col border border-slate-300 rounded">
        <ATMTable
          columns={columns}
          rows={rows}
          rowExtraClasses={() => "min-h-[40px]"}
          isLoading={isTableLoading}
          extraClasses="border-none overflow-auto"
        />
      </div>
    </div>
  );
};

export default PaymentHistoryListing;
